export default "__VITE_ASSET__4FmVS2Uh__"